import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function ReferralRedirectPage() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) {
      navigate(`/login?ref=${code.toUpperCase()}`, { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [code, navigate]);

  return null;
}
